/**
 * @module reducers/SamplePlayer
 */

import { Map } from 'immutable';

import * as SampleConstants from './constants';
import * as D from './deps';

export const INITIAL_STATE = Map({
  [SampleConstants.SamplePlayerKeys.SHOULD_RESUME_TRACK]: false,
  [D.Constants.AudioPlayer.AudioPlayerKeys.PLAYING]: false,
  [D.Constants.AudioPlayer.AudioPlayerKeys.SRC]: '',
  [D.Constants.AudioPlayer.AudioPlayerKeys.ERROR]: false,
  [D.Constants.AudioPlayer.AudioPlayerKeys.ERROR_MSG]: '',
});

// SAMPLEPLAYER REDUCER
export default D.createReducer(INITIAL_STATE, {
  [D.Constants.Samples.SamplePlayerActions.SHOULD_RESUME_TRACK]: shouldResumeTrack,
  [D.Constants.Samples.SamplePlayerActions.PLAYING]: playing,
  [D.Constants.Samples.SamplePlayerActions.STOPPED]: stopped,
  [D.Constants.Samples.SamplePlayerActions.PAUSED]: paused,
});

// CASE FUNCTIONS

function shouldResumeTrack(state, action) {
  return state.set(
    SampleConstants.SamplePlayerKeys.SHOULD_RESUME_TRACK,
    action.data.shouldResumeTrack,
  );
}

function playing(state, { payload }) {
  return state.merge({
    [D.Constants.AudioPlayer.AudioPlayerKeys.PLAYING]: true,
    [D.Constants.AudioPlayer.AudioPlayerKeys.SRC]: payload.url,
  });
}

function stopped(state) {
  return state.merge({
    [D.Constants.AudioPlayer.AudioPlayerKeys.PLAYING]: false,
    [D.Constants.AudioPlayer.AudioPlayerKeys.SRC]: '',
    [SampleConstants.SamplePlayerKeys.SHOULD_RESUME_TRACK]: false,
  });
}

function paused(state) {
  return state.merge({
    [D.Constants.AudioPlayer.AudioPlayerKeys.PLAYING]: false,
    [D.Constants.AudioPlayer.AudioPlayerKeys.SRC]: '',
  });
}
